import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://medical-backend-cgj8.onrender.com/api",
  timeout: 10000,
});

/* ---------- REQUEST ---------- */
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }

    if (!(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* ---------- RESPONSE ---------- */
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {

    const originalRequest = error.config || {};

    if (!originalRequest || originalRequest._retry) {
      return Promise.reject(error);
    }

    if (error.response?.status === 401) {

      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (!refreshToken) throw new Error("No refresh token");

        const res = await axios.post(
          "https://medical-backend-cgj8.onrender.com/api/token/refresh/",
          { refresh: refreshToken }
        );

        localStorage.setItem("accessToken", res.data.access);

        originalRequest.headers.Authorization =
          `Bearer ${res.data.access}`;

        return axiosInstance(originalRequest);

      } catch (e) {
        console.log("REFRESH FAILED", e);
        localStorage.clear();
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;